(function () {
  'use strict';

  angular
    .module('app')
    .component('outgoingPrepaymentRelatedTransactions', outgoingPrepaymentRelatedTransactions());

  function outgoingPrepaymentRelatedTransactions() {
    return {
      bindings: {
        outgoingPrepayment: '<',
      },
      controller: OutgoingPrepaymentRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl: `./app/ajs/prepayment-reports/outgoing-prepayments/components/outgoing-prepayment-related-transactions/outgoing-prepayment-related-transactions.component.html`,
    };
  }

  OutgoingPrepaymentRelatedTransactionsComponent.$inject = [
    'OutgoingPrepaymentService',
    'RelatedTransactionService',
  ];

  function OutgoingPrepaymentRelatedTransactionsComponent(
    OutgoingPrepaymentService,
    RelatedTransactionService
  ) {
    let vm = this;

    // Methods
    vm.openRelatedTransactionModal = openRelatedTransactionModal;
    vm.selectTransaction = selectTransaction;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      OutgoingPrepaymentService.getRelatedTransactions(
        vm.outgoingPrepayment.id,
        vm.outgoingPrepayment.company_id
      ).then(function (data) {
        vm.loadingRelatedTransactions = false;

        vm.outgoingPrepayment = data.outgoingPrepayment;
        vm.paymentProviders = data.paymentProviders;
      });
    }

    function selectTransaction(transaction) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
